import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en', 'fr', 'es', 'pt'],
    defaultLocale: 'en',
    pathnames: {
        '/': '/',
        '/showcase-buyers': {
            en: '/tv-rights-buyers',
            fr: '/acheteurs-droits-tv',
            es: '/compradores-derechos-tv',
            pt: '/compradores-direitos-tv',
        },
        '/showcase-sellers': {
            en: '/tv-rights-sellers',
            fr: '/vendeurs-droits-tv',
            es: '/vendedores-derechos-tv',
            pt: '/vendedores-direitos-tv',
        },
        '/content-programs': {
            en: '/programs',
            fr: '/programmes',
            es: '/programas',
            pt: '/programas',
        },
        '/content-programs/[id]': {
            en: '/programs/[id]',
            fr: '/programmes/[id]',
            es: '/programas/[id]',
            pt: '/programas/[id]',
        },
        '/content-formats': {
            en: '/formats',
            fr: '/formats',
            es: '/formats',
            pt: '/formats',
        },
        '/content-formats/[id]': {
            en: '/formats/[id]',
            fr: '/formats/[id]',
            es: '/formats/[id]',
            pt: '/formats/[id]',
        },
        '/dashboard': {
            fr: '/tableau-de-bord',
            es: '/panel-de-control',
            pt: '/painel-de-controle',
        },
        '/dashboard-programs': {
            fr: '/tableau-de-bord-programmes',
            es: '/panel-de-control-programas',
            pt: '/painel-de-controle-programas',
        },
        '/dashboard-formats': {
            fr: '/tableau-de-bord-formats',
            es: '/panel-de-control-formatos',
            pt: '/painel-de-controle-formatos',
        },
        '/licenses-running': {
            fr: '/licences-en-cours',
            es: '/licencias-en-curso',
            pt: '/licencas-em-curso',
        },
        '/licenses-expired': {
            fr: '/licences-expirees',
            es: '/licencias-caducadas',
            pt: '/licencas-expiradas',
        },
        '/transactions': {
            fr: '/transactions',
            es: '/actas',
            pt: '/transações',
        },
        '/account': {
            fr: '/compte',
            es: '/cuenta',
            pt: '/conta',
        },
        '/settings': {
            fr: '/parametres',
            es: '/ajustes',
            pt: '/configuracoes',
        },
        '/cart': {
            fr: '/panier',
            es: '/carrito',
            pt: '/carrinho',
        },
        '/cart/confirmation-page': {
            fr: '/panier/page-de-confirmation',
            es: '/carrito/pagina-de-confirmacion',
            pt: '/carrinho/pagina-de-confirmacao',
        },
        '/cart/confirmation-page/[id]': {
            fr: '/panier/page-de-confirmation/[id]',
            es: '/carrito/pagina-de-confirmacion/[id]',
            pt: '/carrinho/pagina-de-confirmacao/[id]',
        },
    },
});
